(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["senzo-erfahrungen"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-senzo-loop-toggle]:not([data-senzo-loop-ready])').forEach((button) => {
    button.setAttribute('data-senzo-loop-ready', 'true');
    button.addEventListener('click', () => {
      const community = button.closest('.senzo-proof__community');
      const paused = community.classList.toggle('is-paused');
      button.setAttribute('aria-pressed', paused ? 'true' : 'false');
      button.setAttribute('aria-label', paused ? 'Animation abspielen' : 'Animation pausieren');
      button.textContent = paused ? '▶' : 'Ⅱ';
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["senzo-produktion"] && !Shopify.designMode) return;
  try {
    
  const setupSenzoTemperatureCharts = (root = document) => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    root.querySelectorAll('.senzo-production__temperature-chart').forEach((chart) => {
      if (chart.dataset.countReady === 'true') return;
      chart.dataset.countReady = 'true';

      const values = chart.querySelectorAll('.senzo-production__temperature-row strong');
      const animateValue = (element) => {
        const raw = element.dataset.countValue || element.textContent.trim();
        const match = raw.match(/\d+(?:[.,]\d+)?/);
        if (!match) return;

        element.dataset.countValue = raw;
        const target = Number(match[0].replace(',', '.'));
        const separator = match[0].includes(',') ? ',' : '.';
        const decimals = match[0].includes(',') || match[0].includes('.') ? match[0].split(/[.,]/)[1].length : 0;
        const prefix = raw.slice(0, match.index);
        const suffix = raw.slice(match.index + match[0].length);
        const startedAt = performance.now();
        const duration = 1450;

        const renderFrame = (now) => {
          const progress = Math.min((now - startedAt) / duration, 1);
          const eased = 1 - Math.pow(1 - progress, 4);
          let displayed = (target * eased).toFixed(decimals);
          if (separator === ',') displayed = displayed.replace('.', ',');
          element.textContent = `${prefix}${displayed}${suffix}`;
          if (progress < 1) requestAnimationFrame(renderFrame);
        };

        requestAnimationFrame(renderFrame);
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          values.forEach((value, index) => window.setTimeout(() => animateValue(value), index * 260));
          observer.unobserve(chart);
        });
      }, { threshold: 0.35 });

      observer.observe(chart);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupSenzoTemperatureCharts(), { once: true });
  } else {
    setupSenzoTemperatureCharts();
  }

  document.addEventListener('shopify:section:load', (event) => setupSenzoTemperatureCharts(event.target));

  } catch(e) { console.error(e); }
})();
})();
